import { render, staticRenderFns } from "./RemoteOrderSettings.vue?vue&type=template&id=1dfee24a&scoped=true"
import script from "./RemoteOrderSettings.vue?vue&type=script&lang=js"
export * from "./RemoteOrderSettings.vue?vue&type=script&lang=js"
import style0 from "./RemoteOrderSettings.vue?vue&type=style&index=0&id=1dfee24a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfee24a",
  null
  
)

export default component.exports